import {BaseDataElement} from './base-data-element.model';

export class GlobalValue extends  BaseDataElement {

}
